import { inject, Injectable } from '@angular/core';

import { HasPermissionsService, OperatorEnum } from '@connect-services/client/services/has-permissions.service';
import { PermissionAliasEnum } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class ProjectSettingsPermissionsService {
    private readonly hasPermissions = inject(HasPermissionsService);

    public canAddProjectAccess(): boolean {
        const canManageProject = this.hasPermissions.checkPermissions([PermissionAliasEnum.MANAGE_PROJECT]);
        if (!canManageProject) {
            return false;
        }

        return this.hasPermissions.checkPermissions(
            [PermissionAliasEnum.MANAGE_PERSON, PermissionAliasEnum.READ_PERSON],
            OperatorEnum.OR,
        );
    }

    public canDeleteProjectBase(): boolean {
        return this.hasPermissions.checkPermissions(
            [PermissionAliasEnum.MANAGE_PROJECT, PermissionAliasEnum.MANAGE_LAYER],
            OperatorEnum.AND,
        );
    }

    public canEditProject(): boolean {
        return this.hasPermissions.checkPermissions([PermissionAliasEnum.MANAGE_PROJECT]);
    }

    public canEnterSettings(): boolean {
        return this.hasPermissions.checkPermissions(
            [PermissionAliasEnum.MANAGE_PROJECT, PermissionAliasEnum.READ_PROJECT],
            OperatorEnum.OR,
        );
    }

    public canManageFieldInterventions(): boolean {
        return this.hasPermissions.checkPermissions([PermissionAliasEnum.MANAGE_FIELD_INTERVENTION]);
    }

    public canManageProjectLayer(): boolean {
        return this.hasPermissions.checkPermissions([PermissionAliasEnum.MANAGE_LAYER]);
    }

    public canSeeAccessTab(): boolean {
        return this.hasPermissions.checkPermissions([PermissionAliasEnum.MANAGE_PROJECT]);
    }

    public canSeeDepositsTab(): boolean {
        return this.canEnterSettings();
    }

    public canSeeLayersTab(): boolean {
        return this.canEnterSettings();
    }
}
